import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { CommonService } from 'src/app/services/common-services/common.service';
export interface Speaker {
  id: number;
  name: string;
  department: string;
  image: string;
}
export interface Events {
  id: number;
  name: string;
  date: string;
  venue: string;
  image: string;
  description: string;
  expire: boolean;
  hyperlink: string;
}
@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss']
})
export class EventComponent {
  speakerList: Speaker[] = [];
  eventsList: Events[] = [];
  targetDate = new Date('2024-12-11T13:29:59'); // Set your target date here
  timeLeft: { days: number; hours: number; minutes: number; seconds: number } | null = null;
  private subscription: Subscription | null = null;
  constructor(private router: Router, private commonService: CommonService) {
    // this.startCountdown();
  }
  ngOnInit(): void {
    //this.startCountdown();
    this.getEvents();
    this.getSpeakers();
  }
  getEvents() {
    let apiUrl = 'assets/json/events.json';
    this.commonService.getData(apiUrl).subscribe({
      next: (res: any) => {
        this.eventsList = res.events;
      }
    })
  }
  getSpeakers() {
    let apiUrl = 'assets/json/speaker.json';
    this.commonService.getData(apiUrl).subscribe({
      next: (res: any) => {
        this.speakerList = res.data;
      }
    })
  }
  startCountdown(): void {
    this.subscription = interval(1000).subscribe(() => {
      const now = new Date().getTime();
      const distance = this.targetDate.getTime() - now;

      if (distance < 0) {
        this.timeLeft = null; // Countdown finished
        if (this.subscription) this.subscription.unsubscribe();
      } else {
        this.timeLeft = this.calculateTimeLeft(distance);
      }
    });
  }
  calculateTimeLeft(distance: number) {
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    return { days, hours, minutes, seconds };
  }
  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }
  viewSpeakerDetail(speakerId: number) {
    this.router.navigate([`/speaker/${speakerId}`]);
  }
}
